import React from "react";
import {
  Modal,
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { colors, fonts } from "../../ColorFont/color";
import { url } from "../../ConstUrl/Url";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PlanPurchaseHistoryModal = ({ buyerId, isOpen, onClose }) => {
  const [planPurchaseHistory, setPlanPurchaseHistory] = React.useState([]);

  React.useEffect(() => {
    const fetchPlanPurchaseHistory = async () => {
      try {
        const response = await fetch(
          `${url}/api/users/${buyerId}/plan-purchase-history`
        );
        const data = await response.json();
        setPlanPurchaseHistory(data.planPurchaseHistory);
      } catch (error) {
      }
    };

    fetchPlanPurchaseHistory();
  }, [buyerId]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            fontFamily: fonts.poppins,
            fontSize: 24,
            color: colors.primary_dark,
            fontWeight: 600,
            marginBottom: 2,
          }}
        >
          Plan Purchase History
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                Plan Name
              </TableCell>
              <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                Original Price
              </TableCell>
              <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                Discounted Price
              </TableCell>
              <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                Contacts
              </TableCell>
              <TableCell sx={{ fontFamily: fonts.poppins, fontWeight: 600 }}>
                Purchase Date
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {planPurchaseHistory.map((plan) => (
              <TableRow key={plan.planId}>
                <TableCell sx={{ fontFamily: fonts.poppins }}>
                  {plan.name}
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins }}>
                  {plan.originalPrice}
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins }}>
                  {plan.discountedPrice}
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins }}>
                  {plan.contacts}
                </TableCell>
                <TableCell sx={{ fontFamily: fonts.poppins }}>
                  {plan.purchaseDate}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Modal>
  );
};

export default PlanPurchaseHistoryModal;
